/* TDS shelf: Product / Strain / Price filters, sort, shareable URL state, tier groups, reveal. */
(function () {
  var root = document.querySelector('[data-bx]');
  if (!root) return;
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-group]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-grids] [data-card]'));
  var types = root.querySelectorAll('.bx-type');
  var chips = root.querySelectorAll('.bx-chip[data-strain]');
  var tierChips = root.querySelectorAll('.bx-chip[data-tier]');
  var sortSel = root.querySelector('[data-sort]');
  var countEl = root.querySelector('[data-bx-count]');
  var empty = root.querySelector('[data-empty]');
  var clears = root.querySelectorAll('[data-clear]');
  var clearBtn = root.querySelector('.bx-clear');
  var state = { type: '', strains: [], tiers: [], sort: 'best' };
  var validTypes = [];
  // Shopify search owns ?type= (products/pages/articles), so the search page keeps the filter in ?ptype=
  var TP = /^\/search/.test(location.pathname) ? 'ptype' : 'type';

  // read ?type=flower&strain=indica,hybrid&price=2000&sort=price-asc
  try {
    var q = new URLSearchParams(location.search);
    // Only accept a type that one of the pills offers: search URLs carry Shopify's own type=products
    validTypes = Array.prototype.map.call(types, function (b) { return b.dataset.type; }).filter(Boolean);
    var t = q.get(TP) || '';
    if (!q.has(TP)) { var dt = root.querySelector('[data-default-type]'); if (dt) t = dt.getAttribute('data-default-type'); }
    state.type = validTypes.indexOf(t) > -1 ? t : '';
    state.strains = (q.get('strain') || '').split(',').filter(Boolean);
    state.tiers = (q.get('price') || '').split(',').filter(Boolean);
    state.sort = q.get('sort') || 'best';
  } catch (e) {}

  var writeUrl = function () {
    try {
      var q = new URLSearchParams(location.search);
      if (state.type) q.set(TP, state.type);
      else if (root.querySelector('[data-default-type]')) q.set(TP, 'all');
      else q.delete(TP);
      state.strains.length ? q.set('strain', state.strains.join(',')) : q.delete('strain');
      state.tiers.length ? q.set('price', state.tiers.join(',')) : q.delete('price');
      state.sort !== 'best' ? q.set('sort', state.sort) : q.delete('sort');
      var s = q.toString();
      history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
    } catch (e) {}
  };

  var key = function (c) {
    switch (state.sort) {
      case 'price-asc': return +c.dataset.price;
      case 'price-desc': return -c.dataset.price;
      case 'potency': return -(+c.dataset.potency || 0);
      default: return +c.dataset.i;
    }
  };

  var apply = function () {
    var n = 0;
    cards.forEach(function (c) {
      var ok = (!state.type || c.dataset.type === state.type) &&
        (!state.strains.length || state.strains.indexOf(c.dataset.strain) > -1) &&
        (!state.tiers.length || state.tiers.indexOf(c.dataset.tier) > -1);
      c.hidden = !ok;
      if (ok) n++;
    });
    // sort inside each group, hide groups with nothing left
    groups.forEach(function (g) {
      var grid = g.querySelector('[data-grid]');
      var own = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
      own.sort(function (a, b) { return key(a) - key(b) || (+a.dataset.i - +b.dataset.i); }).forEach(function (c) { grid.appendChild(c); });
      var shown = own.filter(function (c) { return !c.hidden; }).length;
      g.hidden = shown === 0;
      var gc = g.querySelector('[data-group-count]'); if (gc) gc.textContent = shown;
    });
    if (countEl) countEl.textContent = n;
    if (empty) empty.hidden = n > 0;
    types.forEach(function (b) { var on = b.dataset.type === state.type; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    chips.forEach(function (b) { b.setAttribute('aria-pressed', state.strains.indexOf(b.dataset.strain) > -1); });
    tierChips.forEach(function (b) { b.setAttribute('aria-pressed', state.tiers.indexOf(b.dataset.tier) > -1); });
    if (clearBtn) clearBtn.hidden = !(state.type || state.strains.length || state.tiers.length);
    if (sortSel) sortSel.value = state.sort;
    cards.forEach(function (c) { if (!c.hidden) c.classList.add('is-in'); });
    writeUrl();
  };

  var toggleIn = function (arr, v) { var i = arr.indexOf(v); i > -1 ? arr.splice(i, 1) : arr.push(v); };
  types.forEach(function (b) { b.addEventListener('click', function () { state.type = b.dataset.type; apply(); }); });
  chips.forEach(function (b) { b.addEventListener('click', function () { toggleIn(state.strains, b.dataset.strain); apply(); }); });
  tierChips.forEach(function (b) { b.addEventListener('click', function () { toggleIn(state.tiers, b.dataset.tier); apply(); }); });
  if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });
  clears.forEach(function (b) { b.addEventListener('click', function () { state.type = ''; state.strains = []; state.tiers = []; apply(); }); });

  // "added" feedback on the + buttons (the theme's <product-form> does the add and opens the cart)
  root.addEventListener('submit', function (e) {
    var b = e.target.querySelector('.bx-add'); if (!b) return;
    var label = b.querySelector('span'), was = label.textContent;
    setTimeout(function () { b.classList.add('is-added'); label.textContent = 'Added'; }, 350);
    setTimeout(function () { b.classList.remove('is-added'); label.textContent = was; }, 1800);
  }, true);

  // staggered reveal as cards scroll in
  root.classList.add('is-js');
  if ('IntersectionObserver' in window) {
    var k = 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var c = en.target; io.unobserve(c);
        setTimeout(function () { c.classList.add('is-in'); }, (k++ % 4) * 70);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    cards.forEach(function (c) { io.observe(c); });
  }
  apply();
  cards.forEach(function (c) { c.classList.remove('is-in'); });
  cards.forEach(function (c) { var r = c.getBoundingClientRect(); if (r.top < innerHeight) c.classList.add('is-in'); });
  if (!('IntersectionObserver' in window)) cards.forEach(function (c) { c.classList.add('is-in'); });
})();
